import { Button, Tooltip } from '@mui/material';
import { IBankAccountViewModel } from 'viewModels';
import { useBankAccounts } from '../../context/bankAccounts';
import { Container, Content } from './styles';
import { BankAccountType, labelBankAccountType } from '../../types/enums';

interface IBankAccountsProps {
  onCallBack: (bank: IBankAccountViewModel) => void;
  filterAccounts?: (item: IBankAccountViewModel) => boolean;
  selectedBank?: IBankAccountViewModel;
  runningTutorial: boolean;
  elementId?: string;
  correspondentBankAccount?: IBankAccountViewModel[];
  type: 'user' | 'correspondent';
}

export function BankAccounts({
  onCallBack,
  filterAccounts,
  selectedBank,
  type,
  runningTutorial,
  elementId,
  correspondentBankAccount,
}: IBankAccountsProps) {
  const { bankAccounts, returnNameBank } = useBankAccounts();
  const bankAccountTutorial: IBankAccountViewModel[] = [
    {
      accountNumber: '123456',
      agency: '1234',
      bank: '001',
      document: '12345678901',
      holderName: 'Fulano de Tal',
      id: '1',
      isPreferred: true,
      nameBank: 'Banco do Brasil',
      type: BankAccountType.SAVINGS_ACCOUNT,
    },
  ];
  const getDocumentType = (document?: string) => {
    if (!document) return '';
    const cleanedDocument = document.replace(/\D/g, '');
    return cleanedDocument.length === 11 ? 'CPF' : 'CNPJ';
  };

  return (
    <Container>
      {type === 'user' && (
        <>
          {runningTutorial &&
            bankAccountTutorial.map((item) => (
              <Content isActive={selectedBank?.id === item.id} key={item.id} id={elementId}>
                <Button
                  onClick={() => {
                    onCallBack(item);
                  }}>
                  {item.isPreferred && <div className="preferential" />}
                  <div className="container-data-bank">
                    <Tooltip disableInteractive title={item.nameBank} placement="top" followCursor>
                      <p className="nameBank">{returnNameBank(item.bank)}</p>
                    </Tooltip>
                    <div className="bank-information">
                      <div className="group-data">
                        <p>
                          Agência:<span>{item.agency} </span>
                        </p>
                        <p>
                          Conta:<span>{item.accountNumber}</span>
                        </p>
                      </div>
                      <p>
                        Tipo:<span>{labelBankAccountType[item.type]}</span>
                      </p>
                      <p>
                        Nome Titular:<span>{item.holderName}</span>
                      </p>
                      <p>
                        {getDocumentType(item.document)}:<span>{item.document}</span>
                      </p>
                    </div>
                  </div>
                </Button>
              </Content>
            ))}
          {!runningTutorial &&
            bankAccounts.filter(filterAccounts || ((bank) => bank)).map((item) => (
              <Content isActive={selectedBank?.id === item.id} key={item.id}>
                <Button
                  onClick={() => {
                    onCallBack(item);
                  }}>
                  {item.isPreferred && <div className="preferential" />}
                  <div className="container-data-bank">
                    <Tooltip disableInteractive title={item.nameBank} placement="top" followCursor>
                      <p className="nameBank">{returnNameBank(item.bank)}</p>
                    </Tooltip>
                    <div className="bank-information">
                      <div className="group-data">
                        <p>
                          Agência:<span>{item.agency} </span>
                        </p>
                        <p>
                          Conta:<span>{item.accountNumber}</span>
                        </p>
                      </div>
                      <p>
                        Tipo:<span>{labelBankAccountType[item.type]}</span>
                      </p>
                      <p>
                        Nome Titular:<span>{item.holderName}</span>
                      </p>
                      <p>
                        {getDocumentType(item.document)}:<span>{item.document}</span>
                      </p>
                    </div>
                  </div>
                </Button>
              </Content>
            ))}
        </>
      )}
      {type === 'correspondent' && correspondentBankAccount && (
        <>
          {correspondentBankAccount.filter(filterAccounts || ((bank) => bank)).map((item) => (
            <Content isActive={selectedBank?.id === item.id} key={item.id}>
              <Button
                onClick={() => {
                  onCallBack(item);
                }}>
                {item.isPreferred && <div className="preferential" />}
                <div className="container-data-bank">
                  <Tooltip
                    disableInteractive
                    title={returnNameBank(item.bank)}
                    placement="top"
                    followCursor>
                    <p className="nameBank">{returnNameBank(item.bank)}</p>
                  </Tooltip>
                  <div className="bank-information">
                    <div className="group-data">
                      <p>
                        Agência:<span>{item.agency} </span>
                      </p>
                      <p>
                        Conta: <span>{item.accountNumber}</span>
                      </p>
                    </div>
                    <p>
                      Tipo:<span>{labelBankAccountType[item.type]}</span>
                    </p>
                    <p>
                      Nome Titular:<span>{item.holderName}</span>
                    </p>
                    <p>
                      {getDocumentType(item.document)}:<span>{item.document}</span>
                    </p>
                  </div>
                </div>
              </Button>
            </Content>
          ))}
        </>
      )}
    </Container>
  );
}
